import { Item } from '@radix-ui/react-accordion'
import React from 'react'

import { styled } from '~/styled'

export const AccordionItem = styled(Item, {
  base: ['w-full', 'not-last:mb-1']
})
